import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { InputWidthValues } from '../../../../ui/gzInput';

export const templatePackageDeployerForm = document.createElement('template');

templatePackageDeployerForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='package-deployer-form-wrapper'>
    <div class='form-section'>
      <gz-form-field id='deployer-form-field' class='label-mw-250' label=''>
        <gz-dropdown gz-form-input localFiltering type='dropdown'></gz-dropdown>
      </gz-form-field>

      <gz-form-field id='deployer-form-field-validation' class='hidden label-mw-250' label=''>
        <gz-dropdown gz-form-input localFiltering type='dropdown'></gz-dropdown>
      </gz-form-field>

      <div id='deployer-selected-relay'>
        <p id='selected-relay-field'></p>
        <p id='selected-relay-field-value'></p>
      </div>

      <gz-deployer-grid class="hidden"></gz-deployer-grid>

      <div id='custom-communication-section' class='hidden sub-module-section'>
        <gz-form-field id='custom-communication-checkbox'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        </gz-form-field>

        <gz-form-field id='custom-communication-input' class='sub-module'>
          <gz-input gz-form-input placeholder='' inputWidth='${InputWidthValues.LARGE}'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
